// latest: zhangmyh 2017-6-15 8:19 PM
// 机构类型参照
/* global $ u */
import Collection from 'common/vo/collection'
import 'collection/companyCategory'
import { Get, URLs } from 'common'

/* eslint-disable */
let _config
/* eslint-enable */
function init (refer) {
  // 树形控件加载有误,所以需要每次都重新加载
  let tree = Collection.create('company.category')
  let selectItem = null

  let vm = {
    treemodel: tree.datatable,
    treeOption: {
      callback: {
        beforeClick: async function (id, obj) {
          if (!obj.flag) {
            let { data } = await Get(URLs.company_category.url, {
              pid: obj.id
            })

            tree.datatable.addSimpleData(data.result)
            obj.flag = true
          }
          selectItem = obj
        }
      }
    }
  }

  tree.load({ pid: 0 })
  let app = u.createApp()
  app.init(vm, $('#comcategory_refer')[0])

  refer.registerSubmitFunc(function () {
    return selectItem
  })
}
let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    multiSelect: false
  }, config)

  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/companyCategory/index.js